export default __webpack_public_path__ + "static/media/icon-product-login.263f4663.png";